import Cookies from "universal-cookie";

const secureCookieOptions = {
    path: '/',
    secure: window.location.protocol === 'https:',
    sameSite: 'strict',
    maxAge: 4 * 60 * 60 // 4 hours (reduced from 24 for better security)
};

// Specific options for authentication tokens with shorter expiration
const authCookieOptions = {
    path: '/',
    secure: window.location.protocol === 'https:',
    sameSite: 'strict',
    maxAge: 2 * 60 * 60 // 2 hours for auth tokens
};

// For authentication tokens, we cannot use httpOnly in SPAs since JavaScript needs to read them
// This is a fundamental limitation of client-side applications
// Alternative security measures:
// 1. Use SameSite=strict to prevent CSRF
// 2. Use Secure flag for HTTPS-only transmission  
// 3. Implement short token expiration times
// 4. Implement CSP headers to prevent XSS
// 5. Consider using secure, httpOnly refresh tokens with short-lived access tokens

export function getTeamUuid() {
    const cookies = new Cookies();
    return cookies.get("team_uuid");
}

export function getUserUuid() {
    const cookies = new Cookies();
    return cookies.get("user_id");
}

export function getCredits() {
    const cookies = new Cookies();
    return cookies.get("credits");
}

export function setSecureCookie(name, value, options = {}) {
    const cookies = new Cookies();
    // Use auth-specific options for authentication cookies
    const baseOptions = isAuthCookie(name) ? authCookieOptions : secureCookieOptions;
    const mergedOptions = { ...baseOptions, ...options };
    cookies.set(name, value, mergedOptions);
}

function isAuthCookie(name) {
    return ['token', 'user_id', 'team_uuid'].includes(name);
}

export function setSecureCookieWithConsent(name, value, options = {}, consentCheckFn = null) {
    const cookies = new Cookies();
    // Use auth-specific options for authentication cookies
    const baseOptions = isAuthCookie(name) ? authCookieOptions : secureCookieOptions;
    const mergedOptions = { ...baseOptions, ...options };
    
    // Check consent if function is provided
    if (consentCheckFn && !consentCheckFn(name)) {
        console.warn(`Cookie ${name} not allowed based on current consent preferences`);
        return;
    }
    
    cookies.set(name, value, mergedOptions);
}

export function getSecureCookieOptions() {
    return { ...secureCookieOptions };
}

export function isBetaUser() {
    const currentTeamUuid = getTeamUuid();
    const betaUsersString = process.env.REACT_APP_BETA_USERS;
    
    if (!currentTeamUuid || !betaUsersString) {
        return false;
    }
    
    // Split by comma and trim whitespace, convert to array of beta team UUIDs
    const betaUserTeams = betaUsersString.split(',').map(uuid => uuid.trim());
    
    // Check if current team UUID is in the beta users list
    return betaUserTeams.includes(currentTeamUuid);
}
